import { Button, TextInput, Toggle } from "@/ui";
import React, { useState } from "react";
import AuthPage from "@/app/(auth)/components/AuthPage";
import { getTenantInfo } from "@/lib/theme/tenant";
import addSeconds from "date-fns/addSeconds";
import FormikInput from "@/ui/forms/FormikInput";
import Countdown from "@/app/(auth)/components/Countdown";
import { Form, Formik, useFormikContext } from "formik";
import { validateVerifyForm } from "@/app/(auth)/data";

export default function VerificationCodeForm({ onSubmit, onResend }) {
    const [authTime, setAuthTime] = useState(addSeconds(new Date(), 30));

    return (
        <Formik
            initialValues={{ verifyCode: "" }}
            onSubmit={onSubmit}
            validate={validateVerifyForm}>
            {(form) => (
                <AuthPage strapline={`Last Step`}>
                    <h2 className="text-xl font-semibold font-poppins">
                        Please enter your 6-digit verification code
                    </h2>
                    <p className="text-base font-lato mt-1">
                        We have sent a verification code to the phone number
                        linked to your account
                    </p>

                    <Form>
                        <div className="space-y-8 my-8">
                            <FormikInput
                                id="verifyCode"
                                name="verifyCode"
                                label="Verification Code"
                                type="numeric"
                                inputMode="numeric"
                                description="Your code should arrive within 30 seconds"
                            />
                        </div>
                        <div className="space-y-4">
                            <Button
                                id="auth-button"
                                fill
                                type="button"
                                onClick={form.submitForm}
                                disabled={form.isSubmitting || !form.isValid}>
                                Confirm verification code
                            </Button>
                            <Countdown target={authTime}>
                                {({ remaining }) => {
                                    if (remaining <= 0) {
                                        return (
                                            <Button
                                                fill
                                                variant="link"
                                                disabled={form.isSubmitting}
                                                onClick={async () => {
                                                    await onResend();
                                                    setAuthTime(
                                                        addSeconds(
                                                            new Date(),
                                                            30,
                                                        ),
                                                    );
                                                }}>
                                                Resend code
                                            </Button>
                                        );
                                    } else {
                                        return (
                                            <span className="flex items-center justify-center rounded-md px-3.5 py-2.5 text-base w-full font-semibold">
                                                Resend code in 00:
                                                {String(remaining).padStart(
                                                    2,
                                                    "0",
                                                )}
                                            </span>
                                        );
                                    }
                                }}
                            </Countdown>
                        </div>
                    </Form>
                </AuthPage>
            )}
        </Formik>
    );
}
